// config.castellarnau.js
/*
  CICLES (Mercè Carceles)

  NESE
  NESEObservacions

  authSortides

*/

const config = {
  cid: 'a8024893',
  phone: "93 726 94 22",
  email: "secretaria@institutcastellarnau.cat",

  headerLogo:  'img/logo_bn_castellarnau.png',
  headerTitle:  'Institut Castellarnau',
  headerURL: 'https://matricula.institutcastellarnau.cat/',

  enrollmentPostURL: '/post/',
  apiURL: '/api/',

  popupInicial: true,

  validaIDdocuments: true,
  tipusDocTSI: false,

  fotoCarnet: true,    

  telefonObligatori: true,
  carnetFamiliaNombrosa: false,
  
  contacteEmergenciaObligatori: false,

  adjuntMedic: false,
  adjuntMedicObligatori: false,

  datesNoBloquejenInscripcio: false,

  noPreguntarSiEsNouAlumne: false,

  notesAcces: false,

  mostraTorns: true,

  logo: 'img/logo_castellarnau.jpg',
  titol: 'IES Castellarnau',

  favicon: '/img/favicon-castellarnau.ico',
  faviconGestio: '/gestio/img/favicon-castellarnau.ico',

  assignatures: 'assignatures/assignatures.castellarnau.json',
  families: 'families/families.castellarnau.json',
  dadesbancaries: 'dadesbancaries/dadesbancaries.castellarnau.json',
  calculquota: 'quotes.castellarnau.json',   

  treballantFile: false, 
  necessitatsEducativesEspecials: false,
  necessitatsEducativesEspecialsDesplegable: true,

  repetidor: true,
  repetidorsNoPodenAgafarAssignaturesDe2n: true,

  textDadesMediquesAlgunSi: "S’haurà de portar una fotocòpia de la patologia esmentada mitjançant un informe mèdic i donar-li al tutor/a de grup el dia de la presentació.",

  textBotoMatricular: "MATRÍCULA",

  textAlumneNouAlCentre: "Ets alumne/a nou/nova al nostre centre?",
  textAlumneNouAlCentreSub: null,

  urlTPV: "https://matricula.institutcastellarnau.cat/tpv/",
  pagamentTPV: true,
  pagamentTransferencia: false,

  sexeNoBinari: false,

  pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
  pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
  pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

  su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
};

export default config;